import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d7acad56")

_pushScopeId("data-v-d7acad56")
const _hoisted_1 = { class: "appliance-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ApplianceItem = _resolveComponent("ApplianceItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
      return (_openBlock(), _createBlock(_component_ApplianceItem, {
        key: item.id,
        id: item.id,
        imageUrl: item.product.icon,
        productCode: item.product.productCode,
        nickName: _ctx.getNitcName(item.product),
        checked: item.check,
        onSelectCheck: _ctx.selectCheck
      }, null, 8, ["id", "imageUrl", "productCode", "nickName", "checked", "onSelectCheck"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})